import { render, staticRenderFns } from "./updateOrCreateChecklist.vue?vue&type=template&id=38111386"
import script from "./updateOrCreateChecklist.vue?vue&type=script&lang=js"
export * from "./updateOrCreateChecklist.vue?vue&type=script&lang=js"
import style0 from "./updateOrCreateChecklist.vue?vue&type=style&index=0&id=38111386&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports